export const getSite = () => {
  return process.env.VUE_APP_SITE !== undefined
    ? process.env.VUE_APP_SITE
    : '/api/v2/'
  /*
  process.env.VUE_APP_SITE
   */
}
